import React, { useState } from 'react'

export function CriteriaFacet({ criteria, onUpdate }) {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState('')

  if (!criteria?.text && !onUpdate) return null

  function startEdit() {
    if (!onUpdate) return
    setDraft(criteria?.text || '')
    setEditing(true)
  }

  function commitEdit() {
    const text = draft.trim()
    if (text && text !== (criteria?.text || '')) onUpdate?.(text)
    setEditing(false)
  }

  return (
    <div style={styles.facet}>
      <span style={styles.label}>Criteria</span>
      {editing ? (
        <textarea
          style={styles.editArea}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={commitEdit}
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); commitEdit() } }}
          autoFocus
          rows={2}
        />
      ) : (
        <p
          style={{ ...styles.text, ...(onUpdate ? styles.clickable : {}) }}
          onClick={startEdit}
        >
          {criteria?.text || 'Click to set criteria...'}
        </p>
      )}
    </div>
  )
}

const styles = {
  facet: { display: 'flex', flexDirection: 'column', gap: '2px' },
  label: { fontSize: '10px', fontWeight: 600, color: 'var(--text-secondary)' },
  text: { fontSize: '12px', color: 'var(--text-primary)', margin: 0, lineHeight: 1.5 },
  clickable: { cursor: 'pointer', borderBottom: '1px dashed var(--border)' },
  editArea: {
    fontSize: '12px',
    padding: '4px 8px',
    border: '1px solid var(--border)',
    borderRadius: '4px',
    background: 'var(--bg)',
    color: 'var(--text-primary)',
    resize: 'vertical',
    fontFamily: 'inherit',
    lineHeight: 1.5,
  },
}
